import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const womensHealthFeaturesGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#65736c',
    id: 'olive-1',
    position: [10, 5],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#767664',
    id: 'olive-2',
    position: [90, 40],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#73786b',
    id: 'olive-3',
    position: [5, 80],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#687163',
    id: 'olive-4',
    position: [90, 70],
    opacity: 0.7,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#697269',
    id: 'olive-1',
    position: [60, 99],
    opacity: 0.7,
    size: 30,
  },
];

export default womensHealthFeaturesGradients;
